<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="mb-2 float-end d-flex align-items-center">
              <div class="me-2">
                <b-button v-b-modal.new-unit size="sm" variant="primary" class="w-100" @click.prevent="clearFields">
                  <i class="mdi mdi-plus"></i> New Product
                </b-button>
              </div>

              <!-- <div class="me-2" style="flex: 1;">
                <b-button v-b-modal.new-product-import size="sm" variant="success" class="w-100">
                  <i class="mdi mdi-upload"></i> Import Products
                </b-button>
              </div> -->

              <div id="tickets-table_filter" class="me-2">
                <export-excel class="btn btn-sm btn-warning w-100" :data="exportExcelData()" name="STOCK.xls">
                  Export <i class="mdi mdi-upload"></i>
                </export-excel>
              </div>

              <!-- <div style="flex: 1;">
                <button @click="downloadCsv" class="btn btn-secondary btn-sm w-100">
                  <i class="mdi mdi-download"></i> Download Product's Template
                </button>
              </div> -->
            </div>

            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>

            </div>
            <div class="table-responsive">
              <b-table ref="productTable" :items="Items" :fields="Fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  <div class="d-flex">
                    <div style="cursor: pointer;" @click.prevent="data.toggleDetails"
                      @click-outside="data.detailsShowing = false">
                      <i :class="{
                        'mdi mdi-chevron-down fs-3': data.detailsShowing,
                        'mdi mdi-chevron-right fs-3': !data.detailsShowing,
                      }"></i>
                    </div>
                    <div class="ms-2">
                      {{ data.item.name }}
                      <small class="d-block text-info fw-bold">{{ data.item.category.name }}</small>
                    </div>
                  </div>
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                  <small class="d-block text-info fw-bold">{{ data.item.addedon }}</small>
                </template>
                <template #cell(smallest_unit)="data">
                  {{ data.item.smallest_unit.unit_name }}
                  <small class="d-block text-info fw-bold">{{ commas(data.item.smallest_unit.selling_price) }}/=</small>
                </template>

                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button @click="
                      edit(
                        data.item.id,
                        data.item.name,
                        data.item.units,
                        data.item.category.id,
                        data.item.smallest_unit,
                        data.item.smallest_quantity,
                        data.item.bar_code
                      )
                      " type="button" class="btn-sm btn" variant="primary" v-b-modal.edit>
                      <span v-if="loader4"><b-spinner small /></span>
                      <span v-else><i class="mdi mdi-square-edit-outline"></i></span>
                    </b-button>
                    <b-button @click="remove(data.item.id, data.item.name)" type="button" class="btn-sm btn"
                      variant="danger" v-b-modal.delete>
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
                <template #row-details="data">
                  <div style="margin: 0 100px;" class="py-3 rounded d-flex justify-content-evenly shadow-lg">
                    <div class="w-50">
                      <div class="row mb-2">
                        <div class="col-6 text-end"><span class="bg-dark text-white p-1 rounded">Product Unit</span>
                        </div>
                        <div class="col-6"><span class="bg-dark text-white p-1 rounded">Sell Price</span></div>
                      </div>
                      <div class="row" v-for="(unit, index) in data.item.units" :key="index">
                        <div class="col-6 text-end">{{ unit.unit_name }}</div>
                        <div class="col-6">{{ commas(unit.selling_price) }}/=</div>
                      </div>
                    </div>
                    <div class="w-50">
                      <div class="row mb-2">
                        <div class="text-end col-6"><span class="bg-dark text-white p-1 rounded">Batch</span></div>
                        <div class="col-6"><span class="bg-dark text-white p-1 rounded">Expiry Date</span></div>
                      </div>
                      <div class="row" v-for="(batch, index) in data.item.batches" :key="index">
                        <div class="text-end col-6">{{ batch.batch }}</div>
                        <div class="col-6">{{ batch.expiry_date }}</div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
              <!--  <div class="total-payments">
                <strong>Total Buying_Price:</strong>
                {{ commas(totalbuying_price) }}
                <span class="horizontal-separator"> </span>
                <strong>Total Selling_Price:</strong>
                {{ commas(totalselling_price) }}
              </div> -->
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-unit" centered title="New Product" title-class="font-18" hide-footer size="lg">
      <form @submit.prevent="addUnit">
        <div class="row">
          <div class="col-md-6 form-group mb-2">
            <label class="mb-0">Product Name</label>
            <input v-model="product" type="text" required class="form-control" />
          </div>
          <div class="col-md-6 form-group mb-2">
            <label class="mb-0">Category</label>
            <b-form-select required v-model="category" :options="productcategories" class="mb-3 form-control"
              value-field="id" text-field="name"></b-form-select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Smallest Unit</label>
            <!-- supposed to be a b-form-select -->
            <b-form-select v-model="smallest_unit" :options="productunits" class="mb-3 form-control" value-field="id"
              text-field="name" required>
            </b-form-select>

            <!-- supposed to be a b-form-select -->
          </div>
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Min Quantity</label>

            <input readonly v-model="smallest_quantity" type="number" min="1" required class="form-control" />
          </div>
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Selling Price</label>
            <!-- supposed to be a b-form-select -->
            <input v-model="selling_price" required type="number" class="mb-3 form-control" value-field="id"
              text-field="name" />

            <!-- supposed to be a b-form-select -->
          </div>
        </div>
        <center class="lh-1 fw-medium">Bigger Quantities</center>
        <hr />
        <div class="row">
          <div class="col-md-12 form-group mb-3">
            <div class="d-flex align-items-center justify-content-center" v-for="(unit_entry, index) in entries"
              :key="index">
              <div class="me-1">1</div>

              <b-form-select v-model="unit_entry.unit" :options="productunits" class="form-control w-25"
                :class="{ 'text-secondary': unit_entry.unit == '' }" value-field="id" text-field="name">
                <option value="" selected disabled>Unit</option>
              </b-form-select>

              <div class="mx-2">contains</div>
              <input v-model="unit_entry.quantity" placeholder="Quantity" type="number" min="1"
                class="w-25 form-control" />
              <div class="ms-1">
                {{
                  getObjectById(productunits, smallest_unit) || 'smallest unit'

                }}
              </div>
              <h1 class="mx-3">/</h1>
              <input v-model="unit_entry.price" type="number" class="form-control w-25" placeholder="Sell Price" />
              <button @click.prevent="deleteEntry(index)" class="ms-3 btn btn-sm btn-danger">
                <i class="mdi mdi-trash-can"></i>
              </button>
            </div>
          </div>

          <div>
            <center>
              <button @click.prevent="addField" class="btn btn-sm btn-primary py-0">
                <span class="fs-4 fw-bolder">+</span>
              </button>
            </center>
          </div>
        </div>
        <hr />

        <div class="form-group mb-2">
          <label class="mb-0">Bar Code</label>
          <input v-model="bar_code" class="mb-3 form-control" value-field="id" text-field="name" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if=loader><b-spinner small /></span>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="new-product-import" centered title="Upload Products" title-class="font-18" hide-footer>
      <form @submit.prevent="UpLoadProducts">

        <div class="form-group my-2">
          <label class="mb-0">Category</label>
          <b-form-select required v-model="category" :options="productcategories" class="mb-3 form-control"
            value-field="id" text-field="name"></b-form-select>
        </div>

        <div class="form-group my-2">
          <label class="mb-0">Smallest Unit</label>
          <b-form-select v-model="smallest_unit" :options="productunits" class="mb-3 form-control" value-field="id"
            text-field="name" required>
          </b-form-select>
        </div>

        <div class="form-group my-2">
          <label class="mb-0">Select the File</label>
          <input type="file" v-on:change="onLogoChange" class="form-control" />
        </div>

        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-product-import')">Close</b-button>


          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-unit" centered title="Edit Product" title-class="font-14" hide-footer size="lg">
      <form @submit.prevent="editUnit">
        <div class="row">
          <div class="col-md-6 form-group mb-2">
            <label class="mb-0">Product Name</label>
            <input v-model="product" type="text" required class="form-control" />
          </div>
          <div class="col-md-6 form-group mb-2">
            <label class="mb-0">Category</label>
            <b-form-select v-model="category" :options="productcategories" class="mb-3 form-control" value-field="id"
              text-field="name"></b-form-select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Smallest Unit</label>
            <!-- supposed to be a b-form-select -->
            <b-form-select v-model="smallest_unit" :options="productunits" class="mb-3 form-control" value-field="id"
              text-field="name" required>

            </b-form-select>

            <!-- supposed to be a b-form-select -->
          </div>
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Min Quantity</label>
            <input v-model="smallest_quantity" readonly type="number" min="1" required class="form-control" />
          </div>
          <div class="col-md-4 form-group mb-2">
            <label class="mb-0">Selling Price</label>
            <!-- supposed to be a b-form-select -->
            <input v-model="selling_price" required type="number" class="mb-3 form-control" value-field="id"
              text-field="name" />

            <!-- supposed to be a b-form-select -->
          </div>
        </div>
        <center class="lh-1 fw-medium">Bigger Quantities</center>
        <hr />
        <div class="row">
          <div class="col-md-12 form-group mb-3">
            <div class="d-flex align-items-center justify-content-center" v-for="(unit_entry, index) in entries"
              :key="index">
              <div class="me-1">1</div>

              <b-form-select v-model="unit_entry.unit_id" :options="productunits" class="form-control w-25"
                :class="{ 'text-secondary': unit_entry.unit == '' }" value-field="id" text-field="name">
              </b-form-select>

              <div class="mx-2">contains</div>
              <input v-model="unit_entry.base_quantity" placeholder="Quantity" type="number" min="1"
                class="w-25 form-control" />
              <div class="ms-1">
                {{
                  getObjectById(productunits, smallest_unit) || 'smallest unit'

                }}
              </div>
              <h1 class="mx-3">/</h1>
              <input v-model="unit_entry.selling_price" type="number" class="form-control w-25"
                placeholder="Sell Price" />
              <button @click.prevent="deleteEntry(index)" class="ms-3 btn btn-sm btn-danger">
                <i class="mdi mdi-trash-can"></i>
              </button>
            </div>
          </div>

          <div>
            <center>
              <button @click.prevent="addField" class="btn btn-sm btn-primary py-0">
                <span class="fs-4 fw-bolder">+</span>
              </button>
            </center>
          </div>
        </div>
        <hr />

        <div class="form-group mb-2">
          <label class="mb-0">Bar Code</label>
          <input v-model="bar_code" class="mb-3 form-control" value-field="id" text-field="name" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if="loader2"><b-spinner small /></span>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span></b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-unit" centered title="Delete Product" title-class="font-18" hide-footer>
      <form @submit.prevent="removeUnit">
        <input v-model="id" type="hidden" />
        Are you sure you want to delete the Item Unit : <b>{{ product }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="danger">
            <span v-if="loader3"><b-spinner small /></span>
            <span v-else><i class="fas fa-check-circle"></i> YES</span></b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  productcategoryMethods,
  productcategoryComputed,
  unitsMethods,
  itemunitsMethods,
  itemunitsComputed,
  unitsComputed
} from "@/state/helpers";

export default {
  page: {
    title: "Products",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Products",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Products", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },

        {
          key: "name",
          sortable: true,
          label: "Product",
          visible: true,
        },

        {
          key: "smallest_unit",
          label: "Smallest Unit",
          visible: true,
        },
        {
          key: "addedby",
          label: "Added by",
          visible: true,
        },
        {
          key: "actions",
          label: "Actions",
          visible: true,
        },
      ],
      id: "",
      product: "",
      category: "",
      unit: "",
      price: "",
      current_stock: "",
      buying_price: "",
      selling_price: "",
      base_quantity: "",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      date_today: "",
      entries: [],
      smallest_unit: "",
      smallest_quantity: 1,
      bar_code: "",

      expandedRows: [],

      //Loaders
      loader: "",   // For Submitting new product
      loader2: '',  // For Editing a product
      loader3: '',  // For confirming deleting a product
      loader4: '',  // Geting Product info for editing
      table: '',
    };
  },
  computed: {
    ...itemunitsComputed,
    ...unitsComputed,
    ...productcategoryComputed,
    List() {
      return this.productitemunits.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.productitemunits.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.productitemunits.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalbuying_price() {
      return this.productitemunits.reduce(
        (total, item) => total + Number(item.buying_price),
        0
      );
    },
    totalselling_price() {
      return this.productitemunits.reduce(
        (total, item) => total + Number(item.selling_price),
        0
      );
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchItemUnits();
    this.getDatePart();
    this.fetchUnits();
    this.TotalRows = this.productitemunits.length;
    this.isBusy = false;
  },
  methods: {
    ...itemunitsMethods,
    ...unitsMethods,
    ...productcategoryMethods,

    clearFields() {
      this.product = "";
      this.category = "";
      this.entries = [];
      this.smallest_unit = "";
      // this.smallest_quantity = "";
      this.selling_price = "";
      this.bar_code = "";
    },

    getObjectById(array, id) {
      let item = array.find((obj) => obj.id == id);
      return item ? item.name : ''
    },

    addField() {
      this.entries.push({ unit: "", quantity: "", price: "" });
    },

    deleteEntry(index) {
      this.entries.splice(index, 1);
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getDatePart() {
      let today = new Date();
      this.date_today = today;
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(
      id,
      product,
      units,
      category,
      smallest_unit,
      smallest_quantity,
      bar_code
    ) {
      this.loader4 = true
      // clearing fields
      this.product = "";
      this.category = "";
      this.entries = "";
      this.smallest_unit = "";
      this.smallest_quantity = "";
      this.selling_price = "";
      this.bar_code = "";

      this.id = id;
      this.product = product;
      this.category = category;
      this.entries = units;

      this.smallest_unit = smallest_unit;
      this.smallest_quantity = smallest_quantity;
      this.bar_code = bar_code;

      for (let i = 0; i < this.entries.length; i++) {
        const element = this.entries[i];
        if (element.unit_id == this.smallest_unit) {
          this.entries.splice(i, 1);
          this.selling_price = element.selling_price;
          break; // Exit the loop after removing an element
        }
      }

      this.$bvModal.show("edit-unit");
      this.loader4 = false
    },
    remove(id, product) {
      this.id = id;
      this.product = product;
      this.$bvModal.show("delete-unit");
    },
    exportExcelData() {

      return this.productitemunits.map(product => ({
        Name: product.name,
        Category: product.category.name, // Accessing category name
        Batches: product.batches.map(batch => `BAT: ${batch.batch}, QTY: ${batch.quantity}, Buy: ${batch.buying_price}, EXP: ${batch.expiry_date}`).join('\n '), // Flattening batches
        Units: product.units.map(unit => `Unit: ${unit.unit_name}, Sell: ${unit.selling_price}`).join('\n '),
        'Added By': product.addedby,
        'Added On': product.addedon, // Flattening units
      }));
    },


    async downloadCsv() {
      axios.get('/download-csv-product')
        .then(response => {
          // Handle the response (e.g., trigger file download)
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'product.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          // Handle errors
          this.$toast.error('Error downloading CSV:', error);
        });
    },
    onLogoChange(e) { this.importproducts = e.target.files[0]; },
    async UpLoadProducts() {
      const config = { headers: { 'content-type': 'multipart/form-data' } };
      let formData = new FormData();
      formData.append('category', this.category);
      formData.append('smallest_unit', this.smallest_unit);
      formData.append("importproducts", this.importproducts);
      let url = "/uploadproducts";
      await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
          this.$swal({ title: 'Success', text: response.data.message, icon: 'success' });
          this.$bvModal.hide('new-product-import');
          this.importproducts = "";
          this.category = "";
          this.smallest_unit = "";
          this.fetchItemUnits();

        }
      });
    },
    async addUnit() {
      this.loader = true
      const bigger_units = this.entries;
      let obj = {
        product: this.product,
        category: this.category,
        smallest_unit: this.smallest_unit,
        smallest_quantity: this.smallest_quantity,
        selling_price: this.selling_price,
        bigger_units: bigger_units,
        bar_code: this.bar_code,
      };

      let url = "/addproduct";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchItemUnits();
          this.$bvModal.hide("new-unit");
          this.product = "";
          this.smallest_unit = "";
          this.smallest_quantity = "";
          this.unit = "";
          this.selling_price = "";
          this.buying_price = "";
          this.base_quantity = "";
          this.$toast.success('New Product Added!');
        }
        else {
          this.$toast.error('Error Ocuured!')
        }
      });
      this.loader = false
    },

    async editUnit() {
      this.loader2 = true
      const bigger_units = this.entries;
      let obj = {
        id: this.id,
        product: this.product,
        category: this.category,
        smallest_unit: this.smallest_unit,
        smallest_quantity: this.smallest_quantity,
        selling_price: this.selling_price,
        bigger_units: bigger_units,
        bar_code: this.bar_code,
      };

      let url = "/updateproduct";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchItemUnits();
          this.$bvModal.hide("edit-unit");

          this.unit = "";
          this.selling_price = "";
          this.buying_price = "";
          this.base_quantity = "";
          this.$toast.success(`Product: ${this.product} successfully edited`)
          this.product = "";
        }
        else {
          this.$toast.error('Error occured when editing Product!')
        }
      });
      this.loader2 = false
    },

    async removeUnit() {
      this.loader3 = true
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeproduct";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchItemUnits();
          this.$bvModal.hide("delete-unit");
          this.$toast.error('Product Deleted!');
        }
      });
      this.loader3 = false
    },
  },
};
</script>
<style scoped>
.horizontal-separator {
  margin: 0 15px;
}
</style>
